module.exports = __webpack_public_path__ + "img/usericon.7823e4bd.png";